<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
    <div class="row g-0 m-0 p-4 justify-content-start borderb">
        <div class="col-md-11 ps-2 d-flex justify-content-start">
            <span class="popup-title">{{ "SEQUENTIALTOKENLOAD_TITLE" | translate }} {{ "DETAILS" | translate }}</span>
        </div>
        <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
            <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
        </div>
    </div>
    <div class="row g-0 m-0 body p-4 pt-4">
        <div class="member-details p-4">
            <!-- Basic Info -->
            <div class="row g-0 m-0">
                <div class="row g-0 m-0 pt-2 pb-2 d-flex justify-content-start align-items-center">
                    <div class="col-md-6">
                        <span class="item-name">{{ "STATUS" | translate }}</span>
                    </div>
                    <div class="col-md-6 d-flex">
                        <span [style.color]="statusColor(commandInfo?.commandStatus)">{{ commandInfo?.commandStatus || "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo?.assetType || "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "DEVICESETUP_SERVICENAME" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo?.serviceName || "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "DEVICESETUP_METERNO" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo?.meterNo || "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "COMMAND_SOURCE" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo?.source || "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "DATECREATED" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo!.startTime ? (commandInfo!.startTime | date: "d MMMM, y") : "/" }}</span>
                    </div>
                </div>
                <div class="row g-0 m-0 pt-2 pb-2">
                    <div class="col-md-6">
                        <span class="item-name">{{ "TIME" | translate }}</span>
                    </div>
                    <div class="col-md-6">
                        <span class="item-info">{{ commandInfo!.startTime ? (commandInfo!.startTime | date: "shortTime") : "/" }}</span>
                    </div>
                </div>
            </div>
        </div>
        <span class="item-name mt-3 mb-2 d-block">Token Type</span>
        <div class="member-details p-4">
            <ng-container *ngFor="let token of tokens">
                <span class="item-name mt-3 d-block">{{ formatTokenType(token.type) }}</span>
                <div class="member-details p-4">
                    <div class="row g-0 m-0 pt-2 pb-2">
                        <div class="col-md-6">
                            <span class="item-info">{{ "TOKEN_NUMBER" | translate }}</span>
                        </div>
                        <div class="col-md-6">
                            <span class="item-info">{{ token.value }}</span>
                        </div>
                    </div>
                    <div class="row g-0 m-0 pb-2 d-flex justify-content-start align-items-center">
                        <div class="col-md-6">
                            <span class="item-info">{{ "STATUS" | translate }}</span>
                        </div>
                        <div class="col-md-6 d-flex">
                            <span [style.color]="statusColor(token.status)">{{ token.status }}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <!-- Tokens -->
    </div>
    <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
        <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
            <span role="button" class="item-name">{{ "CLOSE_WINDOW" | translate }}</span>
        </div>
    </div>
</div>